import React, { useEffect, Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { SalesPage } from './pages/SalesPage';
import { initMetaPixel } from './utils/metaPixel';
// Lazy-load LujoPage (includes Three.js — heavy bundle)
const LujoPage = lazy(() => import('./pages/LujoPage').then(m => ({
  default: m.LujoPage
})));
export function App() {
  useEffect(() => {
    // Defer pixel init to after page is interactive
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(() => initMetaPixel());
    } else {
      setTimeout(() => initMetaPixel(), 2000);
    }
  }, []);
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<SalesPage data-id="element-3" />} data-id="element-2" />
        <Route path="/lujo" element={<Suspense fallback={<div className="min-h-screen flex items-center justify-center" style={{
        background: '#0a0608'
      }} data-id="element-6">
                  <div className="text-center" data-id="element-7">
                    <div className="w-8 h-8 border-2 rounded-full animate-spin mx-auto mb-3" style={{
            borderColor: 'rgba(201,169,110,0.2)',
            borderTopColor: '#c9a96e'
          }} data-id="element-8" />
                    <p style={{
            color: '#c9a96e',
            fontFamily: "'Playfair Display', serif",
            fontSize: '0.85rem',
            letterSpacing: '0.1em'
          }} data-id="element-9">
                      CARGANDO...
                    </p>
                  </div>
                </div>} data-id="element-5">
              <LujoPage data-id="element-10" />
            </Suspense>} data-id="element-4" />
      </Routes>
    </BrowserRouter>;
}